import { createAsyncThunk } from '@reduxjs/toolkit';
import { type AppIdentityParams, fetchPaymentMethods } from '../utils/serverAPI/fetchPaymentMethods';

export const loadPaymentMethods = createAsyncThunk(
  'LOAD_PAYMENT_METHODS',
  ({ appIdentity, currency, amount }: { appIdentity: AppIdentityParams; currency: string; amount: string }) =>
    fetchPaymentMethods(appIdentity, { currency, amount }).then(({ paymentMethods }) => paymentMethods),
);
